
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "Select"
})
export default class Select extends Vue {
  @Prop({ default: null })
  listArr: any;
  @Prop({ default: null })
  currentItem: string;

  change: void;

  isOpen: boolean = false;
  selectedItem: string = "";

  beforeUpdate() {
    if (this.selectedItem === "" && this.currentItem !== "") {
      this.selectedItem = this.currentItem;
    }
  }

  handleItemSelect(item) {
    this.selectedItem = item.name;
    this.isOpen = false;
    this.$forceUpdate();

    this.$emit("change", item);
    window.removeEventListener("click", this.handleClickWindow, true);
  }

  handleClickWindow() {
    this.isOpen = false;
  }

  handleOpen() {
    setTimeout(() => {
      window.addEventListener("click", this.handleClickWindow, true);
    }, 100);
    this.isOpen = true;
  }
}
